import React from "react";
import "./Frame433.css";

function Frame433(props) {
  const { line36, className } = props;

  return (
    <div className={`frame-43-4 ${className || ""}`}>
      <div className="frame-42-4">
        <div className="group-138-4">
          <p className="how-much-is-the-minimum-advance poppins-normal-tundora-16px">
            How much is the minimum advance?
          </p>
        </div>
        <img className="vector-8" src="/img/vector-4@2x.png" />
      </div>
      <img className="line-36-2" src={line36} />
    </div>
  );
}

export default Frame433;
